import React, { useState, useEffect } from "react";
import "./contactUs.css";
import iconChat from "assets/common/icon_chat.svg";
import iconLocation from "assets/common/icon_location.svg";
import iconCall from "assets/common/icon_call.svg";
import { postQuery, getQuery } from "api";
import { API_ADD_INQUIRY, API_STATE_LIST, API_CITY_LIST } from "utils/apiEndPoints";
import Meta from "utils/meta";
import CountryCodeList from "utils/countryCode";

const Inquiry = () => {
  const [errors, setErrors] = useState({});
  const [stateList, setStateList] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [cityList, setCityList] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [popupMessage, setPopupMessage] = useState({
    message: "",
    type: "",
    visible: false,
  });
  const [inquirySubmitPopup, setInquirySubmitPopup] = useState(false);

  const [inquiryFormData, setInquiryFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    country_code: "+91",
    contact_no: "",
    state_eloc: "",
    city_title: "",
  });

  // form validation
  const inquiryDataValidation = () => {
    const newErrors = {};

    if (!inquiryFormData.first_name) {
      newErrors.first_name = "First Name is required.";
    }
    if (!inquiryFormData.last_name) {
      newErrors.last_name = "Last Name is required.";
    }
    if (!inquiryFormData.email) {
      newErrors.email = "Email is required.";
    } else if (
      !inquiryFormData.email ||
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
        inquiryFormData.email
      )
    ) {
      newErrors.email = "Please enter a valid email address.";
    }
    if (
      !inquiryFormData.contact_no ||
      !/^\d{10}$/.test(inquiryFormData.contact_no)
    ) {
      newErrors.contact_no = "Please enter a valid 10-digit mobile number.";
    }
    if (!inquiryFormData.state_eloc) {
      newErrors.state_eloc = "State is required.";
    }
    if (!inquiryFormData.city_title) {
      newErrors.city_title = "City is required.";
    }
    return newErrors;
  };

  const getStateList = async () => {
    try {
      const stateResponse = await getQuery(API_STATE_LIST);
      if (stateResponse?.data?.success === 1) {
        const stateList = stateResponse?.data?.data?.state;
        setStateList(stateList);
      } else {
        console.error(
          "Error fetching state list: Invalid response",
          stateResponse?.error
        );
      }
    } catch (error) {
      console.error("Error fetching state list:", error.message || error);
    }
  };

  useEffect(() => {
    getStateList();
  }, []);

  const handleStateInputChange = (e) => {
    const selectedEloc = e.target.value;
    const selectedStateData = stateList.find(
      (state) => state.eloc === selectedEloc
    );
    const newErrors = {};
    if (!selectedEloc) {
      newErrors.state_eloc = "State is required.";
    }
    if (selectedStateData) {
      const stateId = selectedStateData.id;
      setSelectedState(selectedEloc);
      setInquiryFormData((prevData) => ({
        ...prevData,
        state_eloc: selectedEloc,
      }));
      setErrors((prevErrors) => ({ ...prevErrors, state_eloc: "" }));
      getCityList(stateId);
    } else {
      console.error("State not found for the selected eloc:", selectedEloc);
      setSelectedState("");
      setInquiryFormData((prevData) => ({
        ...prevData,
        state_eloc: "",
        city_title: "",
      }));
    }
  };

  // Handle city input change
  const handleCityInputChange = (e) => {
    const cityTitleValue = e.target.value;
    const selectedCityObj = cityList.find(
      (city) => city.city === cityTitleValue
    );
    setSelectedCity(cityTitleValue);
    setInquiryFormData((prevData) => ({
      ...prevData,
      city_title: cityTitleValue,
      city_eloc: selectedCityObj.eloc,
    }));
    setErrors((prevErrors) => ({ ...prevErrors, city_title: "" }));
  };

  // Fetch city list based on state ID
  const getCityList = async (stateId) => {
    try {
      const cityListResponse = await getQuery(
        `${API_CITY_LIST}?state_id=${stateId}`
      );

      if (cityListResponse?.data?.success === 1) {
        const cityDataList = cityListResponse?.data?.data?.city || [];
        const filteredCityList = cityDataList.filter(
          (city) => city.state_id === stateId
        );
        setCityList(filteredCityList);
      } else {
        console.error("Failed to fetch city list. Response:", cityListResponse);
        return [];
      }
    } catch (error) {
      console.error("Failed to fetch city list:");
    }
  };

  useEffect(() => {
    getCityList();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInquiryFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrors((prev) => ({ ...prev, [name]: "" }));
  };
  // Submit Inquiry form
  const handleSubmitInquiry = async (e) => {
    e.preventDefault();
    const inquiryValidationErrors = inquiryDataValidation();
    if (Object.keys(inquiryValidationErrors).length > 0) {
      setErrors(inquiryValidationErrors);
      return;
    }
    const inquiryFormRecord = {
      ...inquiryFormData,
    };
    // alert(JSON.stringify(inquiryFormRecord, null, 2));
    try {
      const response = await postQuery(API_ADD_INQUIRY, inquiryFormRecord);
      if (response?.data?.success === 1) {
        inquiryShowPopup(
          "Thank you for your inquiry! Your submission has been received successfully, and our team will get back to you shortly. We appreciate your interest and look forward to assisting you!"
        );
        setInquirySubmitPopup(true);
        setInquiryFormData({
          first_name: "",
          last_name: "",
          email: "",
          country_code: "",
          contact_no: "",
          state_eloc: "",
          city_title: "",
        });
        setSelectedState("");
        setSelectedCity("");
        return true;
      } else {
        inquiryShowPopup("Failed to Submit Your Inquiry!");
        setInquirySubmitPopup(true);
      }
    } catch (error) {
      setErrors({ email: "Error sending OTP. Please try again later." });
    }
  };

  const inquiryShowPopup = (message, type) => {
    setPopupMessage({ message, type, visible: true });

    setTimeout(() => {
      setPopupMessage({ message: "", type: "", visible: false });
    }, 10000);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<div className="container">
      <Meta title="Inquiry | The Realtor Desk" description="" />
        <div className="contactUs-container">
          <div className="contactUs-left">
            <div className="contactUs-left-detail">
              <div className="contactUs-icon">
                <img src={iconChat} alt="Chat to us" />
              </div>
              <div className="contactUs-context">
                <h4>Chat to us</h4>
                <p>Our friendly team is here to help</p>
                <h3>operations@therealtordesk.com</h3>
              </div>
            </div>
            <div className="contactUs-left-detail">
              <div className="contactUs-icon">
                <img src={iconLocation} alt="Visit us" />
              </div>
              <div className="contactUs-context">
                <h4>Visit us</h4>
                <p>Come say hello at our HQ office!</p>
                <h3>
                  406 - The Baroda Crossway, Opp. Police Bhavan , Jail Rd Vadodara
                  Gujarat - India
                </h3>
              </div>
            </div>
            <div className="contactUs-left-detail">
              <div className="contactUs-icon">
                <img src={iconCall} alt="Call us" />
              </div>
              <div className="contactUs-context">
                <h4>Call us</h4>
                <p>Mon-Fri from 10am to 6pm</p>
                <h3> +91 8866550550</h3>
              </div>
            </div>
          </div>
          <div className="contactUs-right">
          <h1>Have Questions? We’re Here to Help!</h1>
          <p>Let us know what you need, and our team will provide the information and support you're looking for.</p>
          <form
            className="contactUs-form"
            noValidate
            onSubmit={handleSubmitInquiry}
            method="POST"
            encType="multipart/form-data"
          >
            <div className={`contactUs-form-row ${errors.first_name ? "input-error" : ""}`}>
              <label htmlFor="first_name">
                <div>First Name<span style={{ color: "red" }}>*</span></div>
                {errors.first_name && (
                    <div className="tooltip">
                      <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                      <div className="tooltip-text">{errors.first_name}</div>
                    </div>
                )}
              </label>
              <input
                type="text"
                placeholder="Enter your first name"
                name="first_name"
                value={inquiryFormData.first_name}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className={`contactUs-form-row ${errors.last_name ? "input-error" : ""}`}>
              <label htmlFor="last_name">
                <div>Last Name<span style={{ color: "red" }}>*</span></div>
                {errors.last_name && (
                    <div className="tooltip">
                      <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                      <div className="tooltip-text">{errors.last_name}</div>
                    </div>
                )}
              </label>
              <input
                type="text"
                placeholder="Enter your last name"
                name="last_name"
                value={inquiryFormData.last_name}
                onChange={handleInputChange}
              />
            </div>
            <div className={`contactUs-form-row ${errors.email ? "input-error" : ""}`}>
              <label htmlFor="email">
                <div>Email<span style={{ color: "red" }}>*</span></div>
                {errors.email && (
                    <div className="tooltip">
                      <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                      <div className="tooltip-text">{errors.email}</div>
                    </div>
                )}
              </label>
              <input
                type="email"
                placeholder="Enter your email"
                value={inquiryFormData.email}
                name="email"
                onChange={handleInputChange}
                required
              />
            </div>
            <div className={`contactUs-form-row ${errors.contact_no ? "input-error" : ""}`}>
              <label htmlFor="contact_no">
                <div>Contact Number<span style={{color: "red"}}>*</span></div>
                {errors.contact_no && (
                    <div className="tooltip">
                      <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                      <div className="tooltip-text">{errors.contact_no}</div>
                    </div>
                )}
              </label>
              <div className="country-code-phone-wrapper">
                <div className="country-code-wrapper select-wrapper">
                  <select
                      name="country_code"
                      value={inquiryFormData.country_code}
                      onChange={handleInputChange}
                      required
                  >
                    {CountryCodeList.map((countryCodes) => (
                        <option key={countryCodes.id} value={countryCodes.code}>
                          {countryCodes.code}
                        </option>))}
                  </select>
                </div>
                <input
                    type="tel"
                    name="contact_no"
                    placeholder="Enter your phone number"
                    minLength="10"
                    maxLength="10"
                    value={inquiryFormData.contact_no}
                    onChange={handleInputChange}
                    required
                    className="reg-contact-no"
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                />
              </div>
            </div>
            <div className={`contactUs-form-row ${errors.state_eloc ? "input-error" : ""}`}>
              <label htmlFor="state_eloc">
                <div>Select State<span style={{ color: "red" }}>*</span></div>
                {errors.state_eloc && (
                    <div className="tooltip">
                      <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                      <div className="tooltip-text">{errors.state_eloc}</div>
                    </div>
                )}
              </label>
              <div className="select-wrapper">
                <select
                  name="state_eloc"
                  value={selectedState}
                  onChange={handleStateInputChange}
                  required
                >
                  <option value="" disabled>
                    Select your state
                  </option>
                  {stateList.map((states) => (
                    <option key={states.id} value={states.eloc}>
                      {states.state}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className={`contactUs-form-row ${errors.city_title ? "input-error" : ""}`}>
              <label htmlFor="city_title">
                <div>Select City<span style={{ color: "red" }}>*</span></div>
                {errors.city_title && (
                    <div className="tooltip">
                      <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                      <div className="tooltip-text">{errors.city_title}</div>
                    </div>
                )}
              </label>
              <div className="select-wrapper">
                <select
                  value={selectedCity}
                  onChange={handleCityInputChange}
                  required
                >
                  <option value="" disabled>
                    Select your city
                  </option>
                  {cityList.map((city) => (
                    <option key={city.id} value={city.city}>
                      {city.city}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <button className="contactUs-next-btn primary" type="submit">
              Submit
            </button>
          </form>
          {inquirySubmitPopup && (
            <div className={`getInquiryPopup ${popupMessage.type}`}>
              {popupMessage.message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Inquiry;
